var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "#4241DD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_15474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 24.5H24.6667C24.2987 24.5 24 24.2013 24 23.8333C24 23.4653 24.2987 23.1667 24.6667 23.1667H28.6667C29.7693 23.1667 30.6667 22.2693 30.6667 21.1667V11.8333C30.6667 10.7307 29.7693 9.83333 28.6667 9.83333H3.33333C2.23067 9.83333 1.33333 10.7307 1.33333 11.8333V21.1667C1.33333 22.2693 2.23067 23.1667 3.33333 23.1667H7.33333C7.70133 23.1667 8 23.4653 8 23.8333C8 24.2013 7.70133 24.5 7.33333 24.5H3.33333C1.49467 24.5 0 23.004 0 21.1667V11.8333C0 9.996 1.49467 8.5 3.33333 8.5H28.6667C30.5053 8.5 32 9.996 32 11.8333V21.1667C32 23.004 30.5053 24.5 28.6667 24.5Z",
    fill: "#4241DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 28.5H11.3334C10.9654 28.5 10.6667 28.2013 10.6667 27.8333C10.6667 27.4653 10.9654 27.1666 11.3334 27.1666H19.3334C19.7014 27.1666 20 27.4653 20 27.8333C20 28.2013 19.7014 28.5 19.3334 28.5Z",
    fill: "#4241DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 25.8333H11.3334C10.9654 25.8333 10.6667 25.5347 10.6667 25.1667C10.6667 24.7987 10.9654 24.5 11.3334 24.5H19.3334C19.7014 24.5 20 24.7987 20 25.1667C20 25.5347 19.7014 25.8333 19.3334 25.8333Z",
    fill: "#4241DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 23.1667H11.3334C10.9654 23.1667 10.6667 22.868 10.6667 22.5C10.6667 22.132 10.9654 21.8334 11.3334 21.8334H14C14.368 21.8334 14.6667 22.132 14.6667 22.5C14.6667 22.868 14.368 23.1667 14 23.1667Z",
    fill: "#4241DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 9.83333C24.2987 9.83333 24 9.53467 24 9.16667V3.83333C24 2.73067 23.1027 1.83333 22 1.83333H10C8.89735 1.83333 8.00002 2.73067 8.00002 3.83333V9.16667C8.00002 9.53467 7.70135 9.83333 7.33335 9.83333C6.96535 9.83333 6.66669 9.53467 6.66669 9.16667V3.83333C6.66669 1.996 8.16135 0.5 10 0.5H22C23.8387 0.5 25.3334 1.996 25.3334 3.83333V9.16667C25.3334 9.53467 25.0347 9.83333 24.6667 9.83333Z",
    fill: "#4241DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 32.5H10C8.16135 32.5 6.66669 31.004 6.66669 29.1667V18.5C6.66669 18.132 6.96535 17.8334 7.33335 17.8334H24.6667C25.0347 17.8334 25.3334 18.132 25.3334 18.5V29.1667C25.3334 31.004 23.8387 32.5 22 32.5ZM8.00002 19.1667V29.1667C8.00002 30.2694 8.89735 31.1667 10 31.1667H22C23.1027 31.1667 24 30.2694 24 29.1667V19.1667H8.00002Z",
    fill: "#4241DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_15474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0328f256fadf33e41b8ed4053f8f5bfa.svg";
export { ForwardRef as ReactComponent };